import { gql } from "apollo-boost";

/* 가맹점 본인 상점 적립내역 */
export const STORE_GRU_SAVING_LIST_QUERY = gql`
  query StoreGruSavingList(
    $commonStatus: String
    $startSearchDate: String
    $endSearchDate: String
    $skip: Int
    $first: Int
  ) {
    StoreGruSavingList(
      commonStatus: $commonStatus
      startSearchDate: $startSearchDate
      endSearchDate: $endSearchDate
      skip: $skip
      first: $first
    ) {
      gruSavings {
        id
        commonStatus
        currency
        amount
        createdAt
        gruSavingInfo {
          id
          name
        }
        user {
          id
          userId
          name
        }
      }
      count
      totalAmount
    }
  }
`;
